// 圖片快取管理
class ImageCache {
  private cache: Map<string, { url: string; timestamp: number }> = new Map();
  private readonly TTL = 50 * 60 * 1000; // GCS signed url 的 TTL 為一個小時, 所以這裡先定 50 分鐘過期

  set(brandId: string, imageId: string, url: string) {
    const key = `${brandId}-${imageId}`;
    this.cache.set(key, { url, timestamp: Date.now() });
  }

  get(brandId: string, imageId: string): string | null {
    const key = `${brandId}-${imageId}`;
    const cached = this.cache.get(key);

    if (!cached) return null;

    // 檢查是否過期
    if (Date.now() - cached.timestamp > this.TTL) {
      this.cache.delete(key);
      return null;
    }

    return cached.url;
  }

  clear() {
    this.cache.clear();
  }
}

const imageCache = new ImageCache();

export default imageCache;
